import type { PivotMeasureFormat } from '@ztechapps/common.contract'
import { PivotNegativeNumberFormatEnum } from '@ztechapps/common.contract'
import { formatNumber } from '@ztechapps/common.utils'

/** Formats an aggregated pivot value with its measure format. */
export const formatPivotValue = (value: number | undefined, format: Required<PivotMeasureFormat>): string => {
  if (value === undefined) return format.nullValue
  // numeral scales a % pattern by 100, so a fraction renders directly as a percent
  let pattern = format.thousandsSeparator ? '0,0' : '0'
  if (format.decimalPlaces > 0) pattern += `.${'0'.repeat(format.decimalPlaces)}`
  if (format.isPercent) pattern += '%'
  // numeral always emits `,` for grouping and `.` for decimals, so swap in the format's own characters
  const amount = formatNumber(Math.abs(value), pattern).replace(/[,.]/g, (char) =>
    char === ',' ? format.thousandsSeparator : format.decimalSeparator
  )
  const text = `${format.currencySymbol}${amount}`
  if (value >= 0) return text
  return format.negativeNumberFormat === PivotNegativeNumberFormatEnum.Parentheses ? `(${text})` : `-${text}`
}
